export default "__VITE_ASSET__9vN0bBjp__"